import _ from 'lodash';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import typeActions from 'redux/typeActions';
import ServiceURL from 'services/ServiceURL';
import { DELETE, GET, POST, PUT } from 'services/ServiceBase';

/**
 *
 * @param {*} data
 * get list provinces:
 * - failed -> call actions failed
 * - success ->
 *      + if (search in select-options) => return;
 *      + if (search in list provinces) => call actions sucess
 */
export function* getProvinces(data) {
  const url = `${ServiceURL.province}?${data.query}&sort[0]=createdAt:DESC`;
  const callback = data.callback;
  const isUpdateReducer = data.isUpdateReducer;
  try {
    const res = yield call(GET, url);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.GET_PROVINCE_FAILED,
        error: res.data?.error?.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      if (isUpdateReducer) {
        yield put({
          type: typeActions.GET_PROVINCE_SUCCESS,
          data: res.data,
        });
      }
      !!callback?.success && callback.success(res.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.GET_PROVINCE_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}

export function* createProvince(data) {
  const url = ServiceURL.province;
  const callback = data.callback;
  try {
    const res = yield call(POST, url, data.params);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.CREATE_PROVINCE_FAILED,
        error: res.data.error.message,
      });

      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      yield put({
        type: typeActions.CREATE_PROVINCE_SUCCESS,
        data: res.data,
      });
      !!callback?.success && callback.success(res.data?.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.CREATE_PROVINCE_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}

export function* deleteProvince(data) {
  const url = ServiceURL.province + '/' + data.params;
  const callback = data.callback;
  try {
    const res = yield call(DELETE, url);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.DELETE_PROVINCE_FAILED,
        error: res.data.error.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      yield put({
        type: typeActions.DELETE_PROVINCE_SUCCESS,
      });
      !!callback?.success && callback.success();
    }
  } catch (error) {
    yield put({
      type: typeActions.DELETE_PROVINCE_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}
export function* updateProvince(data) {
  const url = ServiceURL.province + '/' + data.params;
  const callback = data.callback;
  const res = yield call(PUT, url, data.body);
  try {
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.UPDATE_PROVINCE_FAILED,
        error: res.data.error.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      yield put({
        type: typeActions.UPDATE_PROVINCE_SUCCESS,
        data: res.data?.data,
      });
      !!callback?.success && callback.success(res?.data?.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.UPDATE_PROVINCE_FAILED,
      error: res.data.error.message,
    });
    !!callback?.failed && callback.failed(res.data.error.message);
  }
}
export default function* accountSaga() {
  yield takeLatest(typeActions.GET_PROVINCE_REQUEST, getProvinces);
  yield takeLatest(typeActions.CREATE_PROVINCE_REQUEST, createProvince);
  yield takeLatest(typeActions.DELETE_PROVINCE_REQUEST, deleteProvince);
  yield takeLatest(typeActions.UPDATE_PROVINCE_REQUEST, updateProvince);
}
